import { Box, Text } from 'grommet';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { OrdersTable } from '../../components';

const Dashboard = (): JSX.Element => {
  const history = useHistory();

  return (
    <>
      <Box gap="large" pad={{ top: 'medium' }}>
        <Box>
          <Text size="large" weight="bold" margin={{ bottom: 'small', left: 'medium' }}>Pending</Text>
          <OrdersTable type="Pending Orders" />
        </Box>
        <Box>
          <Text size="large" weight="bold" margin={{ bottom: 'small', left: 'medium' }}>Today's Orders</Text>
          <OrdersTable type="Today's Orders" />
        </Box>
      </Box>
    </>
  );
};

export default Dashboard;
